import { useEffect } from "react";
import { useParams } from "react-router";
import { usePaymentPlan } from "../../../modules/payment/Payment/components/PaymentPlan/hooks/usePaymentPlan";
import { useAppConfiguration } from "../../../../utils/hooks/useAppConfiguration";

export const usePaymentView = () => {
  const { paymentPlanLineId } = useParams();
  const { paymentPlan, getPaymentPlanByPaymentPlanLineId } =
    usePaymentPlan(paymentPlanLineId);

  const { requestGetLoanAndAgent } = useAppConfiguration();

  useEffect(() => {
    getPaymentPlanByPaymentPlanLineId();
  }, []);

  useEffect(() => {
    if (!paymentPlan) return;
    requestGetLoanAndAgent(paymentPlan.external_id);
  }, [paymentPlan]);
};
